import React from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';

import { useDataStore } from 'state/DataStore';

import Page from 'components/Page';

const WalkThrough = observer(() => {
    const dataStore = useDataStore();
    const { unitSlug } = useParams();
    
    const unit = dataStore.getItem('units', 'slug', unitSlug);
    const unitType = dataStore.getItem('unit_types', 'id', unit.acf.unit_type);

    // Check if walkthrough URL exists
    if (!unitType?.acf?.walkthrough_url) {
        return (
            <Page>
                <h3>No walkthrough content available for this unit type.</h3>
            </Page>
        );
    }

    return (
        <Page>
            <iframe
                src={unitType.acf.walkthrough_url}
                title="Unit Walkthrough"
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0
                }}
                allowFullScreen
            />
        </Page>
    );
});

export default WalkThrough;
